import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import MeetingDetail from "./meetingDetail";
import {
    getMeetingById,
    cancelMeeting,
    completeMeeting
} from "services/redux/installation/meetings/action"

const mapStateToProps = (state) => ({
    meetingById: state.meetingReducer.meetingById,
    cancel: state.meetingReducer.cancel,
    complete: state.meetingReducer.complete,

});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getMeetingById,
            cancelMeeting,
            completeMeeting
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(MeetingDetail);
